<template>
  <div class="w-full p-0 lg:pt-8 lg:px-8 flex flex-col justify-center">
    <template v-if="submitSuccess">
      <div class="flex flex-col items-center justify-center h-full">
        <img src="/img/connections/icons/success.png" alt="Checkmark" />
        <h3 class="text-center m-4">Success!</h3>
        <p class="lg:w-1/2 text-center mb-6">Your enquiry has been sent.</p>

        <p class="text-center text-truegray-500">
          Check your emails for a reply soon!
        </p>
      </div>
    </template>

    <template v-else>
      <div class="mb-8">
        <h1 class="text-cw-900">Join CareerWise</h1>
        <p>
          Join the CareerWise community and get your information in front of
          hundreds of thousands of NZ students.
        </p>
      </div>

      <FormulateForm v-model="registerForm" @submit="onSubmit">
        <div class="flex flex-col gap-4">
          <!-- Organisation name -->
          <FormulateInput
            name="orgName"
            label="Organisation name"
            validation="required:trim"
            validation-name="Organisation name"
          />
          <!-- /Organisation name -->

          <!-- Email -->
          <FormulateInput
            name="contactName"
            label="Contact name"
            validation="required:trim"
            validation-name="Contact name"
          />
          <!-- /Email -->

          <!-- Email -->
          <FormulateInput
            name="contactEmail"
            label="Contact email"
            validation="bail|required:trim|email"
            validation-name="Email"
          />
          <!-- /Email -->

          <!-- Comments -->
          <FormulateInput
            name="comments"
            label="Comments"
            type="textarea"
            rows="5"
          />
          <!-- /Comments -->

          <div class="mt-6">
            <FormulateInput
              type="submit"
              :disabled="isSubmitting"
              :input-class="['w-52 btn btn-cw-alt mb-0']"
              :element-class="['flex justify-center']"
            >
              <span
                v-if="isSubmitting"
                class="w-full h-6 flex items-center justify-center"
              >
                <lottie :options="LOADING_ANIMATION_OPTIONS" />
              </span>
              <span v-else> Submit </span>
            </FormulateInput>
          </div>
        </div>
      </FormulateForm>
    </template>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useStore } from '../../../js/store/index.js'
import * as loadingAnimation from '../../../shared/components/loading.json'

export default defineComponent({
  name: 'ModalRegisterOrganisation',

  setup() {
    const store = useStore()

    const LOADING_ANIMATION_OPTIONS = {
      animationData: loadingAnimation.default,
    }

    const registerForm = ref({
      orgName: null,
      contactEmail: null,
      contactName: null,
      comments: null,
    })

    const payload = computed(() => {
      return {
        email: registerForm.value?.contactEmail,
        name: registerForm.value?.contactName,
        organisation: registerForm.value?.orgName,
        comments: registerForm.value?.comments,
      }
    })

    const isSubmitting = ref(false)
    const submitSuccess = ref(false)

    const onSubmit = async () => {
      isSubmitting.value = true
      const responseSuccess = await store.dispatch(
        'contributors/dispatchRegisterOrganisation',
        payload.value,
      )
      isSubmitting.value = false
      submitSuccess.value = responseSuccess
    }

    const initForm = () => {
      registerForm.value.orgName = null
      registerForm.value.contactName = null
      registerForm.value.contactEmail = null
      registerForm.value.comments = null
    }

    onMounted(() => initForm())

    return {
      LOADING_ANIMATION_OPTIONS,

      registerForm,
      isSubmitting,
      submitSuccess,
      onSubmit,
    }
  },
})
</script>
